import { useMutation } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { IOperationResultNoValue, ISatisfactionSurveyResponse } from '../../surveys/models/Api';

export const useClientUpdateSatisfactionResponseMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: IOperationResultNoValue) => void;
	onSuccess?: (data?: ISatisfactionSurveyResponse) => void;
}) => {
	const { apiClient } = useApiClientContext();

	return useMutation({
		mutationFn: ({ response, accessToken }: { response: ISatisfactionSurveyResponse; accessToken: string }) => {
			return apiClient.put<ISatisfactionSurveyResponse>(`survey/satisfaction/response?token=${accessToken}`, response);
		},
		onError,
		onSuccess,
	});
};
